import { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useRemoteScore } from '../hooks/useRemoteScore';

export default function RemoteWatch() {
  const { isConnected, connect, sendCommand } = useRemoteScore();
  // Mesmo protocolo do controle remoto: o app (fonte da verdade) aplica o comando.
  const addPoint = (team) => sendCommand({ type: 'addScore', payload: team });
  const removePoint = (team) => sendCommand({ type: 'removeScore', payload: team });

  // Conectar automaticamente ao carregar
  useEffect(() => {
    connect();
  }, [connect]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        p: 0.5,
        bgcolor: '#FF1493',
      }}
    >
      <Box sx={{
        display: 'flex', alignItems: 'center', gap: 1, width: '95%',
      }}
      >
        <Typography sx={{
          color: 'black', fontWeight: 'bold', fontSize: '1.2rem', minWidth: 24,
        }}
        >
          A:
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => addPoint('A')}
          disabled={!isConnected}
          sx={{ flex: 1, height: 60, minWidth: 0 }}
        >
          +
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => removePoint('A')}
          disabled={!isConnected}
          sx={{
            flex: 1, height: 60, minWidth: 0, fontSize: '1.5rem',
          }}
        >
          −
        </Button>
      </Box>
      <Box sx={{
        display: 'flex', alignItems: 'center', gap: 1, width: '95%',
      }}
      >
        <Typography sx={{
          color: 'black', fontWeight: 'bold', fontSize: '1.2rem', minWidth: 24,
        }}
        >
          B:
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => addPoint('B')}
          disabled={!isConnected}
          sx={{ flex: 1, height: 60, minWidth: 0 }}
        >
          +
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => removePoint('B')}
          disabled={!isConnected}
          sx={{
            flex: 1, height: 60, minWidth: 0, fontSize: '1.5rem',
          }}
        >
          −
        </Button>
      </Box>
    </Box>
  );
}
